import React from 'react';
import classNames from 'classnames';
import DividerButton from './DividerButton';

class RuleDivider extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    if (this.props.last && this.props.addNewRule) {
      this.props.addNewRule(this.props.ruleSetIndex);
    } else if (this.props.last && this.props.addNewRuleSet) {
      this.props.addNewRuleSet();
    }
  }

  render() {
    const { last, addNewRuleSet, addNewRule } = this.props;
    const dividerStyles = classNames('RuleDivider', {
      'ml-16': last && addNewRule,
      'mr-16': last && addNewRule,
      'mt-16': addNewRuleSet,
      'mb-16': addNewRuleSet,
      'RuleDivider--hoverStyles': last,
    });
    const lineStyles = classNames('RuleDivider-line', {
      'RuleDivider-lineHover': last,
      'RuleDivider-line--large': addNewRule,
      'RuleDivider-line--extraLarge': addNewRuleSet,
    });

    return (
      <div
        className={dividerStyles}
        onClick={this.handleClick}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            this.handleClick();
          }
        }}
      >
        {!last && <div className="RuleDivider-line RuleDivider-line--small" />}
        <DividerButton last={last} addNewRuleSet={addNewRuleSet} />
        <div className={lineStyles} />
      </div>
    );
  }
}

export default RuleDivider;
